module.exports = __webpack_public_path__ + "img/violence2.bb0630d3.png";